<div class="wrapper">
  <button
    mat-button
    color="primary"
    class="manager-name"
    [class.manager-name-vertical]="!isVisible()"
    (click)="toggleVisibility()"
  >
    <span>
      {{ releaseCalendarManager().name }}
    </span>
    @if (isVisible()) {
      <span class="manager-plan">
        План мес. {{ formatBudgetValue(releaseCalendarManager().plannedMonthPrice) }} / день {{ formatBudgetValue(releaseCalendarManager().plannedDayPrice) }}
      </span>
    }
  </button>
  @if (isVisible()) {
    <div
      class="manager-content"
      @smoothShowHideWidth
    >
      <div class="manager-month">
        {{ releaseCalendarSelectedOptions().monthName }}
      </div>
      <div class="calendar">
        <div class="calendar-header">
          @for (day of days; track $index) {
            <div class="day">
              {{ day }}
            </div>
          }
        </div>
        <div class="calendar-body">
          @for (day of totalDays(); track $index) {
            <div
              class="day"
              [class.day-empty]="day === 0"
            >
              @if (day !== 0) {
                <div class="day-number">
                  {{ day }}
                </div>
                @if (hasDataForDay(day)) {
                  <div class="day-price">
                    @for (advertisement of releaseCalendarManager().expenses; track $index) {
                      <div>
                        @if (isSameDay(advertisement, day)) {
                          <div>
                            {{ formatBudgetValue(advertisement.price) }} / {{ advertisement.count }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div class="day-price">
                    {{ formatBudgetValue(0) }}
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
